var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"modal-header\">\n<h3 class=\"modal-title\" translate>Istuntosi vanhenee</h3>\n</div>\n<div class=\"modal-body\">\n<p translate>\nTietojesi turvaamiseksi istuntosi vanhenee <strong>{{$ctrl.humanDuration}}</strong> kuluttua. Mikäli haluat jatkaa istuntoa, valitse alta 'Jatka istuntoa'.\n</p>\n</div>\n<div class=\"modal-footer\">\n<normal-button click-action=\"$ctrl.close()\">\n<span translate>Jatka istuntoa</span>\n</normal-button>\n<normal-button is-warning=\"true\" click-action=\"$ctrl.dismiss()\">\n<span translate>Lopeta istunto</span>\n</normal-button>\n</div>\n</div>\n";
var id1="app/common/keepalive/reminder.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/keepalive/reminder.tpl.html
// module id = 371
// module chunks = 6